import { ToastContainer } from 'react-toastify';
import styled, { css } from 'styled-components';

import { resetButton } from 'styles/common';

import 'react-toastify/dist/ReactToastify.css';

export const Root = styled(ToastContainer)<{ $hidden: boolean }>`
  display: block;

  ${(props) =>
    props.$hidden &&
    css`
      &,
      * {
        display: none !important;
      }
    `}

  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    top: 68px;
  }

  .Toastify__toast {
    display: block;
    padding-left: 40px;
    margin-bottom: 10px;
    border-radius: 16px;
    border: 1px solid rgba(155, 89, 182, 0.35);
    background: rgba(10, 8, 30, 0.92);
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.6),
      0 0 1px rgba(155, 89, 182, 0.2);
    backdrop-filter: blur(15px);
    font-family: Roboto;
    color: rgba(255, 255, 255, 0.9);
  }

  .Toastify__toast-body {
    align-items: flex-start;
  }

  .Toastify__progress-bar {
    height: 2px;
    background: linear-gradient(90deg, #6366f1 0%, #a855f7 100%);
  }

  .Toastify__progress-bar--success {
    background: linear-gradient(90deg, #10b981 0%, #5f5 100%);
  }

  .Toastify__progress-bar--error {
    background: linear-gradient(90deg, #f55 0%, #ef4444 100%);
  }

  a {
    display: inline-block;
    margin-top: 5px;
    color: rgba(100, 200, 255, 0.9);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .Toastify__toast-icon {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 18px;
  }

  .Toastify__close-button {
    ${resetButton}
    border-radius: 8px;
    background: transparent;
    transition: 0.15s;
    color: rgba(255, 255, 255, 0.5);

    svg {
      width: auto;
      height: auto;
    }

    svg path {
      fill: rgba(255, 255, 255, 0.5);
    }

    :hover {
      background: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.9);
      transition: 0.15s;

      svg path {
        fill: rgba(255, 255, 255, 0.9);
      }
    }
  }
`;
